export type TRoleRecord = {
    id?: number;
    name: string;
    description?: string;
}

export const EmptyRoleRecord: TRoleRecord = {
    name: '',
    description: '',
}

export type TRole = {
    id: number;
    name: string;
    companyId?: number;
    description?: string;
}